import React, { useContext, useEffect, useState } from "react";
import {
  Box,
  FormButtonStyled,
  HeadingStyled,
  LazyImage,
  SpanStyled,
  TextStyled,
} from "../../../components/styled/Elements";
import AuthHeader from "../../../components/auth/AuthHeader/AuthHeader";
import { Col, Form, Row } from "react-bootstrap";
import ValidatedInput from "../../../components/common/inputFields/ValidatedInput";
import { useForm } from "react-hook-form";
import { ResetPasswordImg } from "../../../components/styled/AllImages";
import { useTranslation } from "react-i18next";
import AuthWelcome from "../../../components/auth/AuthWelcomeCol";
import { LoginWrapper } from "../styled";
import { useNavigate, useSearchParams } from "react-router-dom";
import { info } from "sass";
import { AuthContext } from "../../../context/authContext";
import { useUser } from "../../../context/userContext";

const EmailVerification = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { login } = useContext(AuthContext);
  const { fetchUserInfo } = useUser();
  const [searchParams] = useSearchParams();
  const email = searchParams.get("email");
  const status = searchParams.get("status");
  const token = searchParams.get("token");
  const [isVisible, setIsVisible] = useState(window.innerWidth >= 992);
  useEffect(() => {
    const handelResize = () => {
      setIsVisible(window.innerWidth >= 992);
    };
    window.addEventListener("resize", handelResize);
    return () => {
      window.removeEventListener("resize", handelResize);
    };
  }, []);

  useEffect(() => {
    if (status === "success" && token) {
      const statusTimeout = setTimeout(async () => {
        await login(token);
        const verifiedUser = await fetchUserInfo();
        navigate(
          Number(verifiedUser?.four_step_completed) === 1
            ? "/search-profiles"
            : "/registration"
        );
      }, 5000);

      return () => clearTimeout(statusTimeout);
    }
  }, [status, token]);
  return (
    <LoginWrapper>
      <AuthHeader />
      <Box className="container-fluid containerAuth">
        <Row>
          <Col
            lg={6}
            md={12}
            sm={12}
            className="px-3 px-xl-5 overflow-y-auto authCol"
          >
            <Box className="logSignInner">
              <Box>
                <Box className="mt-5">
                  <HeadingStyled size="34px">
                    {t("email_verification")}
                  </HeadingStyled>
                  <TextStyled
                    size="20px"
                    className="mt-4"
                    color="var(--darkGrey)"
                  >
                    {status === "success"
                      ? t("email_verified_success")
                      : status === "already-verified"
                      ? t("email_already_verified")
                      : t("invalid_link")}
                  </TextStyled>
                  {status === "success" ? (
                    <TextStyled
                      size="18px"
                      color="var(--themeColor)"
                      className="mt-4"
                    >
                      {t("if_not_redirected_click_here")}
                      <SpanStyled
                        color="var(--themeColorSecondary)"
                        className="mx-1"
                        style={{ cursor: "pointer" }}
                        onClick={async () => {
                          login(token);
                          const verifiedUser = await fetchUserInfo();
                          navigate(
                            Number(verifiedUser?.four_step_completed) === 1
                              ? "/search-profiles"
                              : "/registration"
                          );
                        }}
                      >
                        {t("click_here")}
                      </SpanStyled>
                    </TextStyled>
                  ) : status === "already-verified" ? (
                    <Box className="mt-2">
                      <SpanStyled
                        color="var(--themeColorSecondary)"
                        size="18px"
                        style={{ cursor: "pointer" }}
                        onClick={() => navigate("/login")}
                      >
                        {t("please_click_to_login")}
                      </SpanStyled>
                    </Box>
                  ) : null}
                </Box>
              </Box>
            </Box>
          </Col>
          {isVisible && (
            <AuthWelcome logSignImg={ResetPasswordImg} noBorderClass={true} />
          )}
        </Row>
      </Box>
    </LoginWrapper>
  );
};

export default EmailVerification;
